import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const LEFT_TEST_ID = 'Icon-ChevronDoubleLeft';
const RIGHT_TEST_ID = 'Icon-ChevronDoubleRight';

/** Both chevrons of the left-pointing glyph, drawn in a 14px box. */
const CHEVRONS = [
    'M7.7071 0.29289C8.0976 0.68342 8.0976 1.31658 7.7071 1.70711L2.4142 7L7.7071 12.2929C8.0976 12.6834 8.0976 13.3166 7.7071 13.7071C7.3166 14.0976 6.6834 14.0976 6.2929 13.7071L0.29289 7.7071C-0.09763 7.3166 -0.09763 6.6834 0.29289 6.2929L6.2929 0.29289C6.6834 -0.09763 7.3166 -0.09763 7.7071 0.29289Z',
    'M13.7071 0.29289C14.0976 0.68342 14.0976 1.31658 13.7071 1.70711L8.4142 7L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L6.29289 7.7071C5.90237 7.3166 5.90237 6.6834 6.29289 6.2929L12.2929 0.29289C12.6834 -0.09763 13.3166 -0.09763 13.7071 0.29289Z',
];

// The 14px glyph sits centered in a 24px box, 5px in from each edge.
const LEFT_TRANSFORM = 'translate(5 5)';
// Mirrored around the box's vertical axis for the right-pointing variant.
const RIGHT_TRANSFORM = 'translate(19 5) scale(-1 1)';

const ChevronDouble = ({
    fill = 'gcBlue',
    size = 'small',
    transform,
    testId,
}: IconProps & { transform: string; testId: string }) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" data-testid={testId}>
            <g transform={transform}>
                {CHEVRONS.map((d) => (
                    <path key={d} className={fillStyles} fillRule="evenodd" clipRule="evenodd" d={d} />
                ))}
            </g>
        </svg>
    );
};

export const ChevronDoubleLeftIcon = (props: IconProps) => (
    <ChevronDouble {...props} transform={LEFT_TRANSFORM} testId={LEFT_TEST_ID} />
);
ChevronDoubleLeftIcon.TEST_ID = LEFT_TEST_ID;

export const ChevronDoubleRightIcon = (props: IconProps) => (
    <ChevronDouble {...props} transform={RIGHT_TRANSFORM} testId={RIGHT_TEST_ID} />
);
ChevronDoubleRightIcon.TEST_ID = RIGHT_TEST_ID;
